import tokenAbi from "../abis/token.json";
import presaleAbi from "../abis/presale.json";
import stakingAbi from "../abis/staking.json";
import usdtAbi from "../abis/usdt.json";

export const CONTRACTS = {
  TOKEN: "0x1BF22C85Abc7504efe8821456320286faA460fC5",
  PRESALE: "0x870BEe663F147b6eC0852f069007cf480019d010",
  STAKING: "0xFde433bb5eF8F9c62E9b24b7339abA4975c76bf3",
  USDT: "0x8267cF9254734C6Eb452a7bb9bE3c504DAB2148b",
};

export const ABIS = {
  TOKEN: tokenAbi,
  PRESALE: presaleAbi,
  STAKING: stakingAbi,
  USDT: usdtAbi,
};

export const CHAINS = {
  ETHEREUM: Number("1"),
  SEPOLIA: Number("11155111"),
};

export const DECIMALS = {
  TOKEN: Number("18"),
  USDT: Number("6"),
};



